(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("imagepicker", [], factory);
	else if(typeof exports === 'object')
		exports["imagepicker"] = factory();
	else
		root["imagepicker"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 